module.exports = __webpack_public_path__ + "static/media/pic2.1404c0c7.webp";